import { useLanguage } from "@/context/LanguageContext";
import { SERVICE_AREAS_SCHEMA } from "@/config/structuredData";
import { ServiceBookingOptions } from "@/components/ServiceBookingOptions";
import { STATIC_SERVICE_SEO } from "@/config/serviceSeo";
import { Seo } from "@/components/Seo";
import { SectionHeading, LocationCard, Eyebrow, QuoteButton } from "@/components/shared";
import { PRIMARY_LOCATIONS, SECONDARY_LOCATIONS, SATNA_CARD } from "@/config/locations";
import { SITE } from "@/config/site";
import { MapPin } from "lucide-react";

export default function ServiceAreas() {
  const { t } = useLanguage();
  return (
    <>
      <Seo
        title={t(STATIC_SERVICE_SEO.areas.title)}
        description={t(STATIC_SERVICE_SEO.areas.description)}
        jsonLd={SERVICE_AREAS_SCHEMA}
      />
      <section className="bg-[#071426]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-16">
          <Eyebrow className="text-amber-400">{t("Service Areas")}</Eyebrow>
          <h1 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white">{t(STATIC_SERVICE_SEO.areas.h1)}</h1>
          <p className="mt-4 max-w-2xl text-base sm:text-lg text-slate-300">{t("Explore taxi and Tempo Traveller services from our Satna base across the 26 locations below. Select your destination for car hire and cab booking details, pickup arrangements and advance availability confirmation.")}</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
        <div className="flex items-center gap-2"><MapPin className="h-5 w-5 text-amber-600" /><h2 className="text-sm font-bold uppercase tracking-wider text-amber-600">{t("Primary service areas")}</h2></div>
        <p className="mt-2 text-sm text-slate-600 max-w-2xl">{t("Regular routes around our Satna base. These are service areas and destinations, not a claim of a branch office in every town.")}</p>
        <div className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {[SATNA_CARD, ...PRIMARY_LOCATIONS].map((l) => <LocationCard key={l.slug} item={l} />)}
        </div>

        <div className="mt-12 flex items-center gap-2"><MapPin className="h-5 w-5 text-slate-500" /><h2 className="text-sm font-bold uppercase tracking-wider text-slate-500">{t("Secondary (prebooked) destinations")}</h2></div>
        <p className="mt-2 text-sm text-slate-600 max-w-2xl">{t("Longer-distance destinations we serve on a prebooked basis — please plan these in advance.")}</p>
        <div className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {SECONDARY_LOCATIONS.map((l) => <LocationCard key={l.slug} item={l} />)}
        </div>

        <ServiceBookingOptions page="areas" className="mt-12" />

        <div className="mt-12 rounded-2xl bg-[#0B1E36] p-6 sm:p-8 text-center">
          <h2 className="text-xl font-bold text-white">{t("Plan your journey")}</h2>
          <p className="mt-2 text-slate-300">{t("Choose one of the service areas above and share your travel dates, pickup point and group size for a confirmed quote.")}</p>
          <div className="mt-5 flex justify-center"><QuoteButton testId="areas-cta-quote-button">{t("Request a Quote")}</QuoteButton></div>
        </div>
      </section>
    </>
  );
}
